<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Dispositivos"
  [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings"
  p-subtitle="Consulte os dados cadastrados no sistema.">
  <p class="po-font-subtitle">Verifique os dispositivos cadastrados.</p>
  <po-divider></po-divider>
  <br>
    <div class="po-row po-mb-4 shadow">
      <div>
        <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
      </div>
      <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
        (p-show-more)="loadMore()" [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
        [p-spacing]="poTableColumnSpacing" [p-loading-show-more]="!isHideLoading" p-container="border"
        p-hide-columns-manager="false" [p-columns]="columns" [p-items]="items">
      </po-table>
    </div>
  </po-page-list>

  <po-modal #modalDeviceDetails class="modal-device-details" p-size="lg" [p-title]="modalDeviceDetailsTitle"
    p-icon="po-icon po-icon-info" p-click-out="false">
    <div class="modal-device-details-content">
      <po-loading-overlay [hidden]="isHideLoadingDeviceDetails"></po-loading-overlay>

      @if (selectedDevice) {
        <div class="po-row">
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Dispositivo</label>
              <p class="po-field-value">{{ selectedDevice.alias || selectedDevice.name || selectedDevice.id || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">ID</label>
              <p class="po-field-value">{{ selectedDevice.id || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Endereço IP</label>
              <p class="po-field-value">{{ selectedDevice.ipAddress || selectedDevice.ip || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Endereço MAC</label>
              <p class="po-field-value">{{ selectedDevice.macAddress || selectedDevice.mac_address || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Versão do Firmware</label>
              <p class="po-field-value">{{ selectedDevice.firmwareVersion || selectedDevice.firmware_version || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Atualização Automática</label>
              <p class="po-field-value">{{ selectedDevice.autoUpdate ? 'Sim' : 'Não' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Tipo de Fechadura</label>
              <p class="po-field-value">
                @if (selectedDevice.lockType === 1 || selectedDevice.lockType === '1') {
                  <span>Fechadura comum</span>
                }
                @if (selectedDevice.lockType === 0 || selectedDevice.lockType === '0') {
                  <span>Fechadura magnética</span>
                }
                @if (selectedDevice.lockType === null || selectedDevice.lockType === undefined) {
                  <span>N/A</span>
                }
              </p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Status</label>
              <p class="po-field-value">
                <span [class]="getDeviceStatus(selectedDevice) === 'Online' ? 'status-online' : 'status-offline'">
                  {{ getDeviceStatus(selectedDevice) }}
                </span>
              </p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Criado</label>
              <p class="po-field-value">{{ selectedDevice.createdAtFormatted || 'N/A' }}</p>
            </div>
          </div>
          <div class="po-sm-12 po-md-6 po-mb-3">
            <div class="po-field-container">
              <label class="po-field-label">Última Atualização</label>
              <p class="po-field-value">{{ selectedDevice.updatedAtFormatted || 'N/A' }}</p>
            </div>
          </div>
        </div>
      }
    </div>
    <po-modal-footer>
      <po-button p-label="Fechar" p-kind="primary" (p-click)="modalDeviceDetails.close()"></po-button>
    </po-modal-footer>
  </po-modal>

  <!-- Modal Registro de Acesso do Dispositivo -->
  <po-modal #modalDeviceLogs class="modal-device-logs" p-size="xl" [p-title]="modalDeviceLogsTitle" p-icon="po-icon po-icon-list"
    p-click-out="false">
    <div class="modal-device-logs-content">
      <div class="po-row po-mb-3" style="display: flex; align-items: flex-start; justify-content: space-between; gap: 16px;">
        <po-datepicker-range
          class="po-lg-4"
          p-label="Filtrar por período"
          p-name="deviceLogDateRange"
          [(ngModel)]="deviceLogDateRange"
          (p-change)="onDeviceLogDateRangeChange()"
          (p-clean)="clearDeviceLogDateFilter()"
          p-placeholder-start="Data inicial"
          p-placeholder-end="Data final"
          [p-clean]="true"
          p-help="Selecione o período para filtrar os registros de acesso">
        </po-datepicker-range>
        <po-input
          class="po-lg-4"
          style="margin-left: auto;"
          p-label="Pesquisar"
          p-placeholder="Pesquisar por tag"
          [(ngModel)]="deviceLogsSearchText"
          (p-enter)="onDeviceLogsSearchChange()"
          (input)="onDeviceLogsSearchInput($event)"
          (p-blur)="onDeviceLogsSearchBlur()"
          p-icon="po-icon po-icon-search"
          p-clean="true">
        </po-input>
      </div>

      <div class="po-row">
        <div class="table-container-wrapper device-logs-wrapper" style="width: 100%;">
          <div>
            <po-loading-overlay [hidden]="isHideLoadingDeviceLogs"></po-loading-overlay>
          </div>
          @if (deviceLogs.length > 0) {
            <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
              [p-columns]="deviceLogsTableColumns" [p-items]="deviceLogs" p-hide-columns-manager="true"
              (p-show-more)="loadMoreDeviceLogs()" [p-show-more-disabled]="!deviceLogsHasMore"
              [p-loading-show-more]="!isHideLoadingDeviceLogs">
              <ng-template p-table-cell-template let-column="column" let-row="row">
                @if (column.property === 'actions') {
                  <div style="display: flex; justify-content: flex-start; align-items: center; padding-left: 0;">
                    <i class="an an-eye"
                      style="color: #0c9abe; cursor: pointer; font-size: 1.1em; line-height: 1; margin-left: 12px;"
                      (click)="showDeviceLogDetails(row)"
                      title="Ver detalhes do log"></i>
                  </div>
                }
              </ng-template>
            </po-table>
          }
          @if (deviceLogs.length === 0 && isHideLoadingDeviceLogs) {
            <div class="po-text-center po-pt-3">
              <p class="po-font-text" style="color: #999;">Nenhum registro de acesso encontrado</p>
            </div>
          }
        </div>
      </div>
    </div>
    <po-modal-footer>
      <po-button p-label="Fechar" p-kind="primary" (p-click)="modalDeviceLogs.close()"></po-button>
    </po-modal-footer>
  </po-modal>

